import React from "react";

export default function renderIcon({
  width = 22,
  height = 22,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="13.65" stroke={color} stroke-width="0.7" />
      <path
        d="M17.8341 13.2506L11.8941 8.13339C11.7949 8.04777 11.6631 8 11.526 8C11.3889 8 11.2571 8.04777 11.158 8.13339L11.153 8.13941C11.1047 8.18078 11.0662 8.23063 11.0399 8.28592C11.0136 8.3412 11 8.40075 11 8.46093C11 8.52111 11.0136 8.58066 11.0399 8.63594C11.0662 8.69123 11.1047 8.74108 11.153 8.78245L16.745 13.6015L11.153 18.4175C11.1047 18.4589 11.0662 18.5088 11.0399 18.5641C11.0136 18.6193 11 18.6789 11 18.7391C11 18.7993 11.0136 18.8588 11.0399 18.9141C11.0662 18.9694 11.1047 19.0192 11.153 19.0606L11.158 19.0666C11.2571 19.1522 11.3889 19.2 11.526 19.2C11.6631 19.2 11.7949 19.1522 11.8941 19.0666L17.8341 13.9494C17.8865 13.9044 17.9283 13.8502 17.9568 13.7901C17.9853 13.73 18 13.6654 18 13.6C18 13.5346 17.9853 13.47 17.9568 13.4099C17.9283 13.3498 17.8865 13.2956 17.8341 13.2506Z"
        fill={color}
      />
    </svg>
  );
}
